import { WixDataApi } from '@wix/wix-data-core';
import { PlatformizedWixDataProvider, Environment, } from '@wix/wix-data-platformized-provider';
export { Environment } from '@wix/wix-data-platformized-provider';
import { Segment } from '@wix/ambassador-data-v1-data-service/types';
const noopTraceWith = () => (fn) => fn();
export default function createWixData({ cloudDataUrl = '/_api/cloud-data', gridAppId, segment, environment, httpClient, authHeader, traceWith = noopTraceWith, }) {
    const env = environment
        ? environment
        : segment === Segment.LIVE
            ? Environment.LIVE
            : Environment.SANDBOX;
    return new WixDataApi(new PlatformizedWixDataProvider({
        cloudDataUrl,
        gridAppId,
        environment: env,
        httpClient,
        authHeader,
        traceWith,
    }));
}
//# sourceMappingURL=index.js.map